import type { EnhancedFileCitation } from '../types/chat.types';

export const shouldEnhanceCitations = (
  citations: EnhancedFileCitation[] | undefined,
): boolean => {
  if (!Array.isArray(citations) || citations.length === 0) return false;
  return citations.some(citation => !citation.devportal_link);
};
